export enum EChatGroupType {
  ADMIN = 'ADMIN',
  CUSTOMER = 'CUSTOMER'
}
